module.exports = __webpack_public_path__ + "img/广告-5 - 群雄逐鹿.16996ee7.jpg";